// src/api/leads.js
import api from './api';

export const leadsAPI = {
    // Get all leads
    fetchAllLeads: async () => {
        try {
            const response = await api.get(`/api/leads/getAllLeads`);
            return response.data;
        } catch (error) {
            console.error('Error fetching leads:', error);
            throw error;
        }
    },
    // Generate leads
    genarateLeads: async (data) => {
        try {
            const response = await api.post(`/api/leads/generate-leads`, data);
            return response.data;
        } catch (error) {
            console.error('Error generating leads:', error);
            throw error;
        }
    },
    // check remaining calls before Generating leads
    canGenarateLeads: async () => {
        try {
            const response = await api.get(`/api/leads/can-genrate-leads`);
            return response.data;
        } catch (error) {
            console.error('Error checking rate limit before generating leads:', error);
            throw error;
        }
    },
    // getLeadGroups or organization
    getLeadGroups: async () => {
        try {
            const response = await api.get(`/api/leads/getLeadGroups`);
            return response.data;
        } catch (error) {
            console.error('Error in getting leads groups:', error);
            throw error;
        }
    },
};
